<template>
  <div class="content-2">
    <div class="dflex dcolumn">
      <div class="flex align-center">
        <h4 class="text-center text-success font-weight-bold py-3">
          Lista de Spare Parts
        </h4>
      </div>
    </div>

    <hr />

    <div v-if="configInputs != 1" class="card shadow mb-4">
      <div class="card-body">
        <div class="dflex gap justify-center">
          <div>
            <label class="col-form-label font-weight-bold"> Descrição: </label>
            <input
              v-model="v$.desc.$model"
              type="text"
              :class="['form-control', { error: v$.desc.$error }]"
            />
            <div class="text-red" v-if="v$.desc.$error">
              O campo Descrição deve conter no mínimo 3 caracteres.
            </div>
          </div>

          <div>
            <label class="col-form-label font-weight-bold"> Quantidade: </label>
            <input
              v-model="v$.quantidade.$model"
              type="text"
              :class="['form-control', { error: v$.quantidade.$error }]"
              placeholder=""
            />
            <div class="text-red" v-if="v$.quantidade.$error">
              O campo quantidade deve conter no mínimo 1 valor numerico.
            </div>
          </div>

          <div>
            <label class="col-form-label font-weight-bold"> Observação: </label>
            <input
              v-model="v$.observacao.$model"
              type="text"
              class="form-control"
              placeholder=""
              :class="['form-control', { error: v$.observacao.$error }]"
            />
            <div class="text-red" v-if="v$.observacao.$error">
              O campo Descrição deve conter no mínimo 3 caracteres.
            </div>
          </div>

          <div class="dflex align-center">
            <label class="palavra button-success" for="fotoSparePartsEdit"
              ><i class="fas fa-2x fa-camera" aria-hidden="true"></i
            ></label>
            <input
              type="file"
              @change="addFiles"
              id="fotoSparePartsEdit"
              name="fotoSpareParts"
            />
            <button
              @click="addInList"
              type="button"
              class="form-control rounded-circle btn-success"
            >
              <i class="fas fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tableHistorico">
      <table>
        <thead>
          <tr>
            <!-- <th>Id</th> -->
            <th>Descrição</th>
            <th>Quantidade</th>
            <th>Observação</th>
            <th>Preview</th>
            <td v-if="configInputs != 1">Opção</td>
          </tr>
        </thead>
        <tbody v-for="l in list_lsp" :key="l.idp">
          <tr>
            <!-- <td>{{ l.id }}</td> -->
            <td>{{ l.desc }}</td>
            <td>{{ l.quantidade }}</td>
            <td>{{ l.observacao }}</td>
            <td>
              <button type="button" @click="clickPreview(l.preview)">
                <img height="40" width="40" :src="l.preview" />
              </button>
            </td>
            <td v-if="configInputs != 1">
              <button type="button" @click="clickDeleteLSP(l.id)">
                Excluir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, minValue } from "@vuelidate/validators";
export default {
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      list_lsp: [],
      count: 0,
      id: "",
      desc: "",
      quantidade: "",
      observacao: "",
      preview: "",
      file: "",

      ListLSP: "",
    };
  },

  watch: {
    list_lsp: {
      deep: true,
      immediate: true,
      handler(newValue, OldValue) {
        this.$store.commit("MutationImagesLSP", newValue);
      },
    },
  },

  validations() {
    return {
      desc: {
        minLength: minLength(3),
      },
      quantidade: {
        minValueValue: minValue(1),
      },
      observacao: {
        minLength: minLength(3),
      },
    };
  },

  methods: {
    addFiles(event) {
      var input = event.target;

      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.preview = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    addInList() {
      if (
        this.v$.desc.$invalid == true ||
        this.v$.quantidade.$invalid == true ||
        this.v$.observacao.$invalid == true ||
        this.v$.desc.$model == "" ||
        this.v$.quantidade.$model == "" ||
        this.file == ""
      ) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique os dados inputados !",
        });
      } else {
        this.count += 1;
        this.id = this.count;
        const data = {
          id: this.id,
          desc: this.desc,
          quantidade: this.quantidade,
          observacao: this.observacao,
          preview: this.preview,
          file: this.file,
        };

        this.list_lsp.push(data);
        this.$store.commit("MutationImagesLSP", this.list_lsp);
      }
    },

    clickPreview(base64) {
      this.$swal.fire({
        imageUrl: base64,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
      //  this.$swal('Hello Vue world!!!');
    },

    clickDeleteLSP(id) {
      let index = this.list_lsp.findIndex((element) => element.id === id);

      this.list_lsp.splice(index, 1);

      this.$store.commit("MutationImagesLSP", this.list_lsp);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ListSpareParts) {
        dataQuery.ListSpareParts.map((element) => {
          this.list_lsp.push({
            id: element.ID,
            desc: element.DESCRIPTION,
            quantidade: element.QUANTIDADE,
            observacao: element.OBSERVACAO,
            preview: `${this.$store.state.ImgURL}` + `${element.PATH_IMG}`,
            file: "",
          });
        });
      }
    },
  },
};
</script>
s
<style scoped>
input[type="file"] {
  display: none;
}

.dflex {
  display: flex;
}

.dcolumn {
  display: flex;
  flex-direction: column;
}

.dflex.gap {
  gap: 20px;
}

.justify-center,
.dflex.justify-center {
  justify-content: center;
}

.align-center,
.dflex.align-center {
  align-items: center;
}

.fas {
  /* font-weight: 900; */
  font-family: Arial, Helvetica, sans-serif;
}

.text-success {
  color: var(--green) !important;
}

.icon {
  font-size: 18px;
}

.rounded-circle {
  border-radius: 50% !important;
}

.btn-success {
  color: var(--white);
  background-color: var(--green);
  border-color: var(--green);
}

.font-weight-bold {
  font-weight: 700 !important;
}
.text-center {
  text-align: center !important;
}
.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.palavra {
  background-color: var(--blue);
  border-radius: 5px;
  color: var(--white);
  cursor: pointer;
  margin: 10px;
  padding: 6px 10px;
}

.palavra.button-success {
  background-color: var(--green);
}

.btn-success {
  color: var(--white);
  background-color: var(--green);
  border-color: var(--green);
  cursor: pointer;
}

.btn-success:hover {
  background-color: var(--green);
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

@media (max-width: 425px) {
  .dflex {
    flex-direction: column;
  }

  button.form-control {
    width: auto;
  }
}
</style>
